import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { fetchReturnOrderProducts } from '../../../redux/actions/returnedOrderAction';
import capitalizeFirstLetter from '../../comman/capitalizeFirstLetter';

export default function ReturnOrders() {
  const itemsPerPage=10;
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const dispatch=useDispatch();
  const navigate=useNavigate();
  const { returnedproduct=[],totalRecords, error } = useSelector(
    (state) => state.returnProductState
  );

  useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);
      dispatch(fetchReturnOrderProducts(currentPage, itemsPerPage));
    } finally {
      setLoading(false);
    }
  };

  fetchData();
  }, [dispatch,currentPage, itemsPerPage]);

  const totalPages = Math.ceil(totalRecords/ itemsPerPage);

  if (loading) {
    return <p className="text-center mt-10">Loading Return orders...</p>;
  }

  if(error){
    return(<p className="text-red-600">{error}</p>);
  }

  if(!returnedproduct){
    return <p className="text-center mt-10">Loading Return orders...</p>;
  }

  return (
    <div className='py-2 md:py-4 px-0 lg:px-8 xl:px-10'>
      <p className='font-medium text-sm md:text-base xl:text-lg pb-3'>Total : {totalRecords} Returned orders</p>
      {returnedproduct.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-8">
        {returnedproduct.map((row,idx)=>(
        <>
        <div className="flex flex-col space-y-1 justify-between border border-pink-200 rounded-md p-2 md:p-4 bg-[#fcf8f8]" key={idx}>
                <p className="font-medium text-sm md:text-base xl:text-lg">{row.orderId}</p>
                <p className="text-xs md:text-sm xl:text-base">Product name : {capitalizeFirstLetter(row.orderItem.product.productName)}</p>

                <p className="text-xs md:text-sm xl:text-base">
                    Return Date: {new Date(row.createdAt).toLocaleDateString("en-US", 
                    {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    })}
                </p>
                <p>Order Status :{" "} 
                <span className={`text-xs md:text-sm xl:text-base font-medium ${
                    row.returnStatus === "pending"
                    ? "text-yellow-500"
                    : row.returnStatus === "accepted"
                    ?"text-green-500"
                    : row.returnStatus === "rejected"
                    ? "text-red-500"
                    : "text-gray-400"
                  }`}
                >{capitalizeFirstLetter(row.returnStatus)}</span></p>
                <p className="text-xs md:text-sm xl:text-base">Pick up status : {capitalizeFirstLetter(row.pickupStatus)}</p>
                <div className='flex justify-end items-end'>
                    <button className="text-xs md:text-sm 2xl:text-base border rounded-md px-2 py-0.5 text-center  bg-blue-100 text-blue-700 border-blue-700"
                        onClick={() => navigate(`/return-order-detail/${row.id}`,{ state: { activeStep: 3 }})}>
                            View Details
                    </button>
                </div>
        </div>
        </>
        ))}
        </div>
      ) : (
        <div className="text-gray-600 flex flex-col justify-center space-y-4 w-full">
          <p>No orders found for your account.</p>
          <Link to="/">
            <button className="px-4 py-2 bg-[#A63F40] text-white rounded">Explore Products</button>
          </Link>
        </div>
    )}

    {totalPages > 1 && (
        <div className="flex justify-center items-center gap-2 mt-10 flex-wrap">
          <button
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {"<<"}
          </button>
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {"<"}
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((page) =>
              page === 1 ||
              page === totalPages ||
              Math.abs(currentPage - page) <= 1
            )
            .reduce((acc, page, i, arr) => {
              if (i > 0 && page - arr[i - 1] > 1) acc.push("...");
              acc.push(page);
              return acc;
            }, [])
            .map((page, i) =>
              page === "..." ? (
                <span key={`dots-${i}`} className="px-2 py-1 text-sm text-gray-500">...</span>
              ) : (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-1 text-sm rounded border font-medium ${
                    currentPage === page
                      ? "bg-pink-600 text-white"
                      : "hover:bg-pink-100"
                  }`}
                >
                  {page}
                </button>
              )
            )}

          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {">"}
          </button>
          <button
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {">>"}
          </button>
        </div>
    )}

    </div>

  )
}

